import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";

export const loanFeatures = [
    SubscriptionFeature.CanAccessLoans,
    SubscriptionFeature.LoanFullDetails,
    SubscriptionFeature.LoanHistoricalIssuance,
    SubscriptionFeature.LoanFiltersAndSearch,
    SubscriptionFeature.LoanColumnCustomizer,
    SubscriptionFeature.LoanExport
]